import { useLocation, useNavigate, useParams } from "react-router-dom";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import Header from "./header";
import MobileHeader from "./MobileHeader";
import Footer from "./footer";
import { useMediaQuery } from "react-responsive";
import PostActions from "./LikeCommentActions";
import { toast } from "react-toastify";
import { useCallback, useEffect, useState } from "react";
import DropdownActions from "./DropdownActions";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function ViewerPage({data}) {
  const token = localStorage.getItem("access_token");
 
  const { userId: id } = useParams();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { state } = useLocation();
  const postId = state?.postId;
  const [currentUserId, setCurrentUserId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [invitations, setInvitations] = useState([]);
  const [editedTitle, setEditedTitle] = useState(state.title || "");
  const [isLiked, setIsLiked] = useState(state.is_Liked || false);
  const [likeCount, setLikeCount] = useState(state.likeCount || 0);
  const [editedDescription, setEditedDescription] = useState(
    state.description || state.abstract || ""
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [publication, setPublication] = useState({
    title: state.title || "",
    description: state.description || state.abstract || "",
    userId: state.userId || null,
  });
  const [loading, setLoading] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (/\.html?$/i.test(state.url)) {
      fetch(state.url)
        .then((res) => res.text())
        .then((text) => setHtmlContent(text))
        .catch((err) => console.error("Error loading HTML file:", err));
    }
  }, [state.url]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchInvitations = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/user/publication/view-received-invitation-list/`,
          {
            headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY  },
          }
        );
        setInvitations(res.data?.data || []);
      } catch (err) {
        console.error("Failed to fetch invitations:", err);
      }
    };

    fetchInvitations();
  }, []);

  const handleEdit = () => {
    setEditedTitle(publication.title || "");
    setEditedDescription(publication.description || state.abstract || "");
    setEditMode(true);
  };
  const handleApply = async () => {
    if (!editedTitle.trim()) {
      toast.error("Title cannot be empty");
      return;
    }
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/user/publication/publication/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
           Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: JSON.stringify({
          id: state.postId,
          title: editedTitle,
          abstract: editedDescription,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        toast.success("Publication updated successfully!");
        setPublication({
          title: data.data.title,
          description: data.data?.description || data.data?.abstract || "",
          userId: data.data.user,
        });
        setEditedTitle(data.data.title);
        setEditedDescription(
          data.data?.description || data.data?.abstract || ""
        );
        setEditMode(false);
      } else {
        toast.error(data?.message || "Failed to update publication");
      }
    } catch (error) {
      toast.error("Update failed");
    } finally {
      setLoading(false);
    }
  };
  console.log({ currentUserId, ownerId: publication.userId });

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/user/publication/publication/`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
           Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: JSON.stringify({ id: state.postId }),
      });
      if (res.status === 204 || res.ok) {
        toast.success("Publication deleted successfully!");
        navigate(-1);
      } else {
        const data = await res.json();
        toast.error(data?.message || "Failed to delete publication");
      }
    } catch (error) {
      toast.error("Deletion failed");
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
  };

  const fetchCurrentUser = useCallback(async () => {
    try {
      const res = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
        headers: { Authorization: `Bearer ${token}`,  "x-api-key": process.env.REACT_APP_X_API_KEY, },
      });
      const data = await res.json();
      if (res.ok) {
        setCurrentUserId(data.data?.user);
        localStorage.setItem("user_id", data.data?.user);
      } else {
        console.error("");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error getting user profile.");
    }
  }, [BASE_URL, token]);

  useEffect(() => {
    fetchCurrentUser();
  }, [fetchCurrentUser]);

  useEffect(() => {
    const fetchSinglePublication = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/user/publication/publication/?id=${postId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY
            },
          }
        );

        const data = await res.json();
        if (!res.ok)
          throw new Error(data.message || "Failed to fetch publication");
        setPublication({
          title: data.data?.title || "",
          description: data.data?.description || data.data?.abstract || "",
          userId: data.data?.user || null,
        });
      } catch (error) {
        console.error("Publication fetch error:", error.message);
      }
    };

    if (postId) fetchSinglePublication();
  }, [postId]);

  if (!state?.url) return <p>No document to display</p>;

  const fileType = state.url.split(".").pop().toLowerCase();
  const isPDF = fileType === "pdf";

  const docs = [
    {
      uri: state.url,
      fileType: fileType,
    },
  ];

  return (
    <>
  {isMobile ? <MobileHeader hideHamburger /> : <Header />}
  
  <div className="px-4 md:px-6 py-6">
    <div className="max-w-6xl mx-auto">
      {/* Top Header */}
      <div className="bg-white rounded-xl p-4 md:p-6 mb-6">
        <div className="flex items-center justify-between gap-4">
          {/* Left Side: Back Button + Title */}
          <div className="flex items-center gap-4">
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigate(-1);
              }}
              className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
            >
              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
            </button>

            <div>
              <h2 className="text-xl font-semibold text-gray-900">
                {editMode ? editedTitle : publication.title || "Document Viewer"}
              </h2>
            </div>
          </div>

          {/* Right Side: Dropdown Actions */}
          {currentUserId &&
            publication.userId &&
            (currentUserId === publication.userId ||
              invitations.some((inv) => inv.can_edit)) && (
              <div className="flex items-center">
                <DropdownActions
                  onEdit={handleEdit}
                  onDelete={currentUserId === publication.userId ? handleDelete : undefined}
                />
              </div>
            )}
        </div>

        {/* Description */}
        <div className="mt-4">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <h3 className="text-sm font-semibold text-gray-700">
              Description
            </h3>
          </div>
          <p className="text-gray-600">
            {editMode ? editedDescription : publication.description || "No description"}
          </p>
        </div>
      </div>

      {/* Edit Mode */}
      {editMode && (
        <div className="bg-white rounded-xl p-6 mb-6 border border-gray-200">
          <div className="space-y-4">
            {publication.title !== undefined && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Title</label>
                <input
                  type="text"
                  value={editedTitle}
                  onChange={(e) => setEditedTitle(e.target.value)}
                  placeholder="Enter title"
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
                />
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
              <textarea
                value={editedDescription}
                onChange={(e) => setEditedDescription(e.target.value)}
                placeholder="Enter description"
                className="w-full min-h-[120px] p-4 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 resize-y transition-all"
              />
            </div>

            <div className="flex gap-3 pt-4">
              <button
                onClick={handleApply}
                disabled={loading}
                className="flex-1 py-2.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {loading ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    Saving...
                  </>
                ) : (
                  "Save Changes"
                )}
              </button>
              <button
                onClick={() => setEditMode(false)}
                className="flex-1 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Document Viewer */}
      <div className="bg-white rounded-xl border border-gray-200 p-4 mb-6">
        <div className="border border-gray-300 rounded-xl overflow-hidden bg-white">
          {isPDF ? (
            <iframe
              src={state.url}
              title={state.title || "PDF Viewer"}
              className="w-full h-[600px] border-0"
            />
          ) : /\.(png|jpe?g|gif)$/i.test(state.url) ? (
            <img
              src={state.url}
              alt={publication.title || "Image Viewer"}
              className="w-full h-auto object-contain max-h-[600px]"
            />
          ) : /\.html?$/i.test(state.url) ? (
            <div className="p-6 bg-gray-50">
              <pre className="text-sm text-gray-800 whitespace-pre-wrap break-words font-mono">
                <code>{htmlContent}</code>
              </pre>
            </div>
          ) : (
            <DocViewer
              documents={docs}
              pluginRenderers={DocViewerRenderers}
              style={{ height: "600px", width: "100%" }}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                },
              }}
            />
          )}
        </div>
      </div>

      {/* Social Actions */}
      {state.type === "publication" && currentUserId && (
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <h3 className="text-sm font-semibold text-gray-700">Actions</h3>
          </div>
          <PostActions
            postId={state.postId}
            type={state.type}
            is_Liked={state.is_Liked === true}
            likeCount={state.likeCount}
            commentCount={state.commentCount}
            currentUser={currentUserId}
            onLikeChange={(postId, liked) => {
              setPublication((prev) => ({
                ...prev,
                is_liked: liked,
                total_likes: liked
                  ? prev.total_likes + 1
                  : prev.total_likes - 1,
              }));
            }}
          />
        </div>
      )}

      {/* Delete Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md">
            <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 text-center mb-2">Delete Publication?</h3>
            <p className="text-gray-600 text-center mb-6">This action cannot be undone.</p>
            <div className="flex gap-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="flex-1 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="flex-1 py-2.5 bg-red-500 text-white font-medium rounded-xl hover:bg-red-600 transition-colors"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
  
  <Footer />
</>
  );
}
